import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <section className="bg-slate-900 py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-amber-400/10 rounded-full flex items-center justify-center">
              <FileText className="w-8 h-8 text-amber-400" />
            </div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Terms of Service</h1>
        </div>
      </section>
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-8 text-slate-700 leading-relaxed">
            <p>By using a2insure.com, you agree to these terms. This website is operated by Anderson & Anderson Insurance LLC, Crown Point, Indiana.</p>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Informational purposes only</h2>
              <p>The content on this site is general information about insurance products and services. It is not legal, tax, or financial advice, and it does not describe any specific policy. Coverage terms, conditions, and exclusions are governed solely by the policy issued to you.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>No coverage through this website</h2>
              <p>Insurance coverage cannot be bound, changed, or cancelled through this website, through website forms, by email, or by voicemail. Coverage changes are effective only when confirmed in writing by a licensed agent of the agency. Quotes provided through this site or by our team are estimates based on the information you provide and are not a guarantee of coverage or premium.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Acceptable use</h2>
              <p>You agree to use this site lawfully and to provide accurate information when submitting forms.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Third-party links</h2>
              <p>This site links to third-party services (for example, LegalShield). We are not responsible for the content or privacy practices of third-party sites.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Intellectual property</h2>
              <p>The content, logos, and design of this site belong to Anderson & Anderson Insurance LLC and may not be reproduced without permission.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>Limitation of liability</h2>
              <p>To the fullest extent permitted by law, the agency is not liable for damages arising from use of this website. These terms are governed by the laws of the State of Indiana. Questions: customerservice@a2insure.com, (219) 779-7040.</p>
            </div>
          </div>
          <div className="mt-12 pt-8 border-t border-slate-200 text-center">
            <Link to="/" className="inline-flex items-center px-6 py-3 bg-slate-900 text-white rounded-lg hover:bg-slate-800 transition-colors">Back to Home</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
